import { Modal, Button, InputNumber, Col, Row, notification } from 'antd'
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom';
const backend_url = process.env.REACT_APP_BACKEND_URL








function timeDifference(startTime, endTime) {
  const toMinutes = (time) => {
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
  };

  const startMinutes = toMinutes(startTime);
  const endMinutes = toMinutes(endTime);

  // Handle the case where the end time is on the next day
  let diffMinutes = endMinutes >= startMinutes ? endMinutes - startMinutes : (1440 - startMinutes) + endMinutes;

  const hours = Math.floor(diffMinutes / 60);
  const minutes = diffMinutes % 60;

  return { hours, minutes };
}



function BusCard({ bus, date }) {


  const navigate = useNavigate();
  const myData = useSelector(data => data.userdetailreducer)

  const [visible, setVisible] = useState(false);
  const [seatCount, setSeatCount] = useState(null);
  const [seatColor, setSeatColor] = useState('text-green-800')

  const [vacantSeat, setVacantSeat] = useState(null);


  const { hours, minutes } = timeDifference(
    bus.timing.split(' - ')[0],
    bus.timing.split(' - ')[1]
  );





  function formatDate(date) {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString();

    const formattedDate = `${day}-${month}-${year}`;
    return formattedDate;
  }


  const handleCancel = () => {
    setSeatCount('')

    setVisible(false);
  };

  const onChange = (value) => {
    setSeatCount(value);
  };

  const showModal = () => {
    setVisible(true);

  };




  async function bookTicket() {

    const checkedLogin = localStorage.getItem('userdatatoken')

    if (checkedLogin) {


      if (!seatCount) {
        notification.error({
          message: ' Please Select number of Seat'
        });
        return
      }
      if (seatCount > vacantSeat) {
        notification.error({
          message: `only ${vacantSeat} seat/s available please select max ${vacantSeat} seats`
        });
        return
      }


      const prefix = "NBTCK"; // Define the prefix
      const timestamp = Date.now(); // Get the current timestamp
      const nineDigitNumber = timestamp.toString().slice(-9);
      const ticketNumber = `${prefix}${nineDigitNumber}`




      try {
        const bookingData = {
          ticketNumber: ticketNumber,
          fromCity: bus.fromStation,
          toCity: bus.toStation,
          busName: bus.name,
          seatNumber: seatCount,
          busNumber: bus.number,
          travelDate: formatDate(date),
          username: myData.username,
          status: 'booked'
        };
        // console.log('date', bookingData)

        const response = await axios.post(`${backend_url}/api/book-seat`, bookingData);
        // const response = await axios.post  (`http://localhost:8000/api/book-seat`, bookingData);

        if (response.status === 201) {
          console.log('Booking successful:', response.data);
          handleCancel()
          notification.success({
            message: ' Seat Booked Successfull',
            description: `${bookingData.seatNumber} seat/s booked successfully`,

          });
          
        } else {
          console.log('Booking failed:', response.data);
        }
      }
      catch (error) {
        console.error('Error booking the ticket:', error);
      }

    }
    else {
      notification.error({
        message: ' Please login First',
      });
      navigate('/login')
    }


  }




  // Logic to get number of seats



  async function vacantSeats() {
    // console.log(bus.number)
    // console.log(formatDate(date))
    try {
      const response = await axios.get(`${backend_url}/api/get-bookings`, {
        // const response = await axios.get(`http://localhost:8000/api/get-bookings`, {

        params: {
          busNumber: bus.number,  // Make sure bus.number is correct
          travelDate: formatDate(date)  // Ensure formatDate(date) returns the correct format
        }
      });

      const bookings = response.data; // Store the response data in a variable
      const remainSeat = bookings.reduce((sum, booking) => sum + booking.seatNumber, 0);
      // console.log(bookings); // Log the response data
      if (bus.seats - remainSeat > 0) {

        setVacantSeat(bus.seats - remainSeat); // Log the response data
      } else {

        setVacantSeat(0); // Log the response data
      }



      const totalSeats = bus.seats; // Total number of seats
      const remainingSeats = bus.seats - remainSeat; // Remaining seats
      const percentageRemaining = (remainingSeats / totalSeats) * 100; // Calculate percentage of remaining seats

      if (percentageRemaining > 50) {
        setSeatColor('text-green-800'); // More than 50% remaining, set green
      } else if (percentageRemaining > 25 && percentageRemaining <= 50) {
        setSeatColor('text-yellow-500'); // Between 25% and 50% remaining, set yellow
      } else {
        setSeatColor('text-red-600'); // Below 25% remaining, set red
      }





    } catch (error) {
      console.error('Error fetching bookings:', error);
    }
  }





  useEffect(() => {
    vacantSeats()
  }, [vacantSeat])





  return (
    <>




      <div className="w-[95vw] my-5 max-w-7xl bg-transparent border border-gray-400 rounded-lg shadow-lg p-4 mx-auto">
        <p className="bg-blue-400 p-3 text-left sm:text-left text-lg font-semibold rounded-md mb-4">
          <span className="text-red-700">Start From</span> @{bus.fromStation} - {bus.timing.split(' - ')[0]} on {formatDate(date)}
        </p>
        <div className="travelinfo">
          <Row gutter={[16, 16]} className="justify-center sm:justify-start">
            {/* Column 1: Name, Bus Type */}
            <Col xs={24} sm={12} md={8} lg={4}>
              <div className="info p-4 bg-blue-100 rounded-lg border border-gray-300 text-black flex flex-col justify-center h-full text-center sm:text-left">
                <span className="name text-[16px] font-semibold">{bus.name}</span>
              </div>
            </Col>

            {/* Column 2: Departure Time, Date, Station */}
            <Col xs={24} sm={12} md={8} lg={4}>
              <div className="dep p-4 bg-blue-100 rounded-lg border border-gray-200 flex flex-col justify-center h-full text-center sm:text-left">
                <div className="departure text-xl font-medium">{bus.timing.split(' - ')[0]}</div>
                <div className="venue text-gray-500 mt-1">{bus.fromStation}</div>
              </div>
            </Col>

            {/* Column 3: Travel Duration */}
            <Col xs={24} sm={12} md={8} lg={2}>
              <div className="time flex items-center justify-center h-full text-center sm:text-left">
                <div className="time-value text-l font-medium">
                  {hours} hr {minutes} min
                </div>
              </div>
            </Col>

            {/* Column 4: Arrival Time, Date, Station */}
            <Col xs={24} sm={12} md={8} lg={4}>
              <div className="arive p-4 bg-blue-100 rounded-lg border border-gray-200 flex flex-col justify-center h-full text-center sm:text-left">
                <div className="arival text-xl font-medium">{bus.timing.split(' - ')[1]}</div>
                <div className="venue text-gray-500 mt-1">{bus.toStation}</div>
              </div>
            </Col>

            {/* Column 5: Rating and Number of People Rated */}
            <Col xs={24} sm={12} md={8} lg={4}>
              <div className="rating p-4 bg-blue-100 rounded-lg border border-gray-200 flex flex-col justify-center h-full text-center sm:text-left">
                <div className="stars text-yellow-500 text-xl">★★★★☆</div>
                <div className="rated text-gray-600 mt-1">120 rated</div>
              </div>
            </Col>

            {/* Column 6: Price */}
            <Col xs={24} sm={12} md={8} lg={2}>
              <div className="price p-4 bg-blue-100 rounded-lg border border-gray-200 flex items-center justify-center h-full text-center sm:text-left">
                <div className="price-value text-l font-medium">₹{bus.fare || 'Not Available'}</div>
              </div>
            </Col>

            {/* Column 7: Number of Seats Available */}
            <Col xs={24} sm={12} md={8} lg={4}>
              {/* <div className="seats-available p-4 bg-blue-100 rounded-lg border border-gray-300 flex items-center justify-center h-full text-center sm:text-left"
        > */}
              <div className={`seats-available p-4 bg-blue-100 rounded-lg border border-gray-300 flex items-center justify-center h-full text-center sm:text-left ${seatColor}`}
              >
                <div className="seats-value text-l font-medium">{vacantSeat} seats available</div>
              </div>
            </Col>
          </Row>
        </div>

        {/* Centering Button for Mobile */}
        <div className="flex justify-center sm:justify-start mt-5">
          <Button onClick={showModal} className="bg-green-500 text-white text-md font-bold py-2 px-4 rounded-md transition-all hover:bg-green-600 w-full sm:w-auto" disabled={vacantSeat === 0} >
            Book now
          </Button>
        </div>
      </div>






      <Modal
        title="How many seat you want to book?"
        visible={visible}
        onCancel={handleCancel}
        footer={null}
        centered
        className="p-4 rounded-lg shadow-lg"
        style={{ width: '90%', maxWidth: '60%' }} // 90% on mobile, max 60% on desktop/tablet
      >
        <div className="flex flex-col items-center justify-center space-y-4">
          {/* Input Field */}
          <InputNumber
            min={1}
            max={bus.seats}
            onChange={onChange}
            className="w-full sm:w-3/4 md:w-2/3 lg:w-1/2 p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-green-500"
            placeholder="Enter number of seats you want to book"
            value={seatCount}
          />

          {/* Button */}
          <Button
            className="
      mt-5 bg-green-500 text-white font-bold w-full 
      sm:w-3/4 md:w-1/3 lg:w-1/4 
      py-2 sm:py-1.5 text-base sm:text-sm md:text-lg 
      rounded-lg transition-all duration-300 hover:bg-green-600"
            onClick={bookTicket}
          >
            Book Now
          </Button>
        </div>
      </Modal>





    </>
  )
}

export default BusCard